import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Button from 'gatsby-theme-core/src/components/button/index';
import CoreImage from 'gatsby-theme-core/src/components/image';
import Section from 'gatsby-theme-pdv/src/components/section';

const ShopItem = ({
  product,
  rowOptions,
  CTAbuttonText: buttonText,
  className,
}) => (!product ? null : (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      <Inner>
        <div>
          <Image
            image={product.image}
            alt={product.name}
          />
        </div>
        <article>
          <Title>{product.name}</Title>

          <Prices>
            {product.salePrice && (
              <>
                <SalePrice>{product.regularPrice}</SalePrice>
                <Price>{product.salePrice}</Price>
              </>
            )}
            {!product?.salePrice && (
              <Price>{product.regularPrice}</Price>
            )}
          </Prices>

          <StyledButton href={`https://shop.dcdw.nl${product.uri}`}>{buttonText}</StyledButton>
          &nbsp;
          &nbsp;
          <StyledButton outline to="/shop">Bekijk onze shop</StyledButton>
        </article>
      </Inner>
    </Container>
  </Section>
));

const Image = styled(CoreImage)`
  display: block !important;
  margin: 0 auto;
  width: 75%;
  margin-bottom: 1rem;

  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    width: auto;
    margin-bottom: 0;
  }
`;

const StyledButton = styled(Button)`
  display: block;
  min-width: 188px;
  text-align: center;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    display: inline-block;
  }
`;

const Price = styled.span`
  font-family: ${(props) => props.theme.standoutFontFamily};
  display: block;
  color: ${(props) => props.theme.grayColor};
  font-size: 1.556rem;
  font-weight: 700;
`;

const SalePrice = styled.span`
  text-decoration: line-through;
  margin-right: .5rem;
`;

const Prices = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 0;
`;

const Title = styled.h2`
  margin: 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
`;

const Inner = styled.div`
  @media all and (min-width: ${(props) => props.theme.breakingpoints.md}) {
    display: grid;
    grid-auto-rows: auto;
    grid-template-columns: 1fr 2fr;
    grid-gap: 4rem;
    align-items: center;
  }
`;

export default styled(ShopItem)``;
